
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import DashboardSection from '../../components/feature/DashboardSection';
import FeaturesSection from '../../components/feature/FeaturesSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import CTASection from '../../components/feature/CTASection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <DashboardSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
